// AUTO-GENERATED from SEO team's Google Sheet. Do not edit by hand.
// Each key maps to an array of JSON-LD schema objects placed in <head> for that landing page.

const schemas = {
  "facial-services-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-led, medical-grade custom facial treatments for Mission Valley, Hillcrest, North Park, Kensington and Downtown San Diego.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Kensington, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Downtown San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Facial Services San Diego",
        "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Services San Diego",
              "serviceType": "Facial",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facials San Diego CA",
              "serviceType": "Facial",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Medspa Facials San Diego",
              "serviceType": "Medspa Facial",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Custom Facial San Diego",
              "serviceType": "Custom Facial",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Spa San Diego",
              "serviceType": "Facial Spa",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Clinician-Led Facials",
              "serviceType": "Clinician-Led Facial",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Medical-Grade Facial Treatments",
              "serviceType": "Medical-Grade Facial",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Spa near Mission Valley",
              "serviceType": "Facial Spa",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Spa near Hillcrest",
              "serviceType": "Facial Spa",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Hillcrest, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Spa near North Park",
              "serviceType": "Facial Spa",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "North Park, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Spa near Kensington",
              "serviceType": "Facial Spa",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Kensington, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Facial Spa Downtown San Diego",
              "serviceType": "Facial Spa",
              "url": "https://zenithwellnesss.com/facial-services-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Downtown San Diego, CA"
              }
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is a custom facial, and what does it include at Zenith Wellness?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A custom facial is a facial treatment tailored to your skin type, concerns and goals. At our San Diego facial spa, we start with an intake and consultation. Then we choose the right treatment, such as a Signature, Deluxe or Platinum HydraFacial, and add boosters or LED light therapy where they fit."
          }
        },
        {
          "@type": "Question",
          "name": "How much do facial services cost in San Diego, CA?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Facial services at Zenith Wellness start at $199 for the Signature HydraFacial. The Deluxe is $249 and the Platinum is $299. Advanced options include Signature Microneedling ($325) and VI Peel ($300 per session). Members save 10\u201320%, and financing is available."
          }
        },
        {
          "@type": "Question",
          "name": "Which facial treatment is right for me?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "It depends on your skin and goals. Hydration and glow suit a HydraFacial, texture and collagen support suit microneedling, and pigment concerns may call for a peel or our Zenith Bright program. Book a complimentary consultation and we'll recommend the best fit."
          }
        },
        {
          "@type": "Question",
          "name": "What's the difference between the Signature, Deluxe and Platinum HydraFacial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The Signature (45 min) cleanses, extracts and hydrates. The Deluxe (60 min) adds lymphatic drainage. The Platinum (75 min) adds LED light therapy, lymphatic drainage and a personalized booster for the most customized facial."
          }
        },
        {
          "@type": "Question",
          "name": "How long does a facial treatment take?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most facials take 45 to 75 minutes. The Zen Revive & Glow package runs 75 to 90 minutes. New clients complete a brief intake form, so arrive a few minutes early."
          }
        },
        {
          "@type": "Question",
          "name": "Is there downtime after a facial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "HydraFacials typically involve little to no downtime, so most clients return to normal activities right away. Microneedling and peels can cause temporary redness or flaking. We'll explain what to expect and how to care for your skin afterward."
          }
        },
        {
          "@type": "Question",
          "name": "How often should I get a facial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Many clients book a facial monthly for maintenance. Advanced treatments like microneedling and VI Peel are often done as a series. During your consultation we'll map out a schedule that fits your skin and budget, and a membership can make regular visits more affordable."
          }
        },
        {
          "@type": "Question",
          "name": "Where is your facial spa in San Diego, and what are your hours?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We're at 3727 Camino Del Rio S, Suite 210, San Diego, CA 92108. We're open Monday, Wednesday, Thursday and Saturday from 9am to 3pm, and Friday by appointment. Contact us to book."
          }
        }
      ]
    }
  ],
  "microneedling-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-led microneedling (percutaneous collagen induction therapy) for Mission Valley, Hillcrest, North Park, La Jolla and surrounding San Diego neighborhoods.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "La Jolla, San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Microneedling San Diego",
        "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling San Diego",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling San Diego CA",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Percutaneous Collagen Induction Therapy",
              "serviceType": "Percutaneous Collagen Induction Therapy",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Collagen Induction Therapy San Diego",
              "serviceType": "Collagen Induction Therapy",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling Clinic Mission Valley",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Clinician-Led Microneedling",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling near Mission Valley",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling near Hillcrest",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Hillcrest, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling near North Park",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "North Park, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling near La Jolla",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "La Jolla, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Microneedling 92108",
              "serviceType": "Microneedling",
              "url": "https://zenithwellnesss.com/microneedling-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "San Diego, CA 92108"
              }
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is microneedling?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Microneedling, or percutaneous collagen induction therapy, uses fine sterile needles to create controlled micro-channels in the skin, triggering natural collagen and elastin production for smoother, firmer, more even-toned skin over time."
          }
        },
        {
          "@type": "Question",
          "name": "Does microneedling hurt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A topical numbing cream is applied before treatment, so most clients describe the sensation as mild pressure or light scratching rather than pain. Some redness, similar to a light sunburn, is normal for 24\u201348 hours afterward."
          }
        },
        {
          "@type": "Question",
          "name": "What's the difference between Microneedling, Microneedling + PRP, and Microneedling + Exosomes?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Signature Microneedling is the foundational treatment. Microneedling + PRP adds your own platelet-rich plasma to accelerate healing, while Microneedling + Exosomes uses exosomes for our most advanced, results-accelerated option."
          }
        },
        {
          "@type": "Question",
          "name": "How many microneedling sessions do I need to see results?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Many clients notice improved glow after one session, but a series of 3 sessions spaced about a month apart is typically recommended for meaningful, lasting improvement in texture, scarring, and tone."
          }
        },
        {
          "@type": "Question",
          "name": "Can microneedling help with acne scars?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Microneedling is commonly used to improve the appearance of acne scarring by stimulating collagen remodeling in scarred tissue over a series of sessions."
          }
        },
        {
          "@type": "Question",
          "name": "How long does microneedling downtime last?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most clients experience mild redness for 24\u201348 hours, comparable to a light sunburn, with no significant downtime required. Makeup can typically be reapplied the next day."
          }
        },
        {
          "@type": "Question",
          "name": "Is microneedling safe for all skin types?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Microneedling is generally well-suited to a wide range of skin types and tones. Our clinicians will review your skin history during your consultation to confirm the right approach and tier for you."
          }
        },
        {
          "@type": "Question",
          "name": "Where can I get microneedling in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Zenith Wellness is located in Mission Valley at 3727 Camino Del Rio S, Suite 210, San Diego, CA 92108, serving clients throughout Hillcrest, North Park, La Jolla, and the greater San Diego area. Book online or call 858-905-4117."
          }
        }
      ]
    }
  ],
  "neurotoxins-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-administered neurotoxin treatments including Botox, Dysport and Jeuveau for Mission Valley, Hillcrest, North Park, La Jolla and surrounding San Diego neighborhoods.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "La Jolla, San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Botox & Neurotoxin Treatments San Diego",
        "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox San Diego",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Neurotoxin Treatment San Diego",
              "serviceType": "Neurotoxin Treatment",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox Cosmetic San Diego",
              "serviceType": "Botox Cosmetic",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Dysport San Diego",
              "serviceType": "Dysport",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Jeuveau San Diego",
              "serviceType": "Jeuveau",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Neuromodulator Injections San Diego",
              "serviceType": "Neuromodulator Injection",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Tox Injections San Diego",
              "serviceType": "Neurotoxin Injection",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox Clinic Mission Valley",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox near Mission Valley",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox near Hillcrest",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Hillcrest, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox near North Park",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "North Park, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox near La Jolla",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "La Jolla, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Best Botox San Diego",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Botox Injector near Me",
              "serviceType": "Botox",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Neurotoxin Clinic 92108",
              "serviceType": "Neurotoxin Treatment",
              "url": "https://zenithwellnesss.com/neurotoxins-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "San Diego, CA 92108"
              }
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is a neurotoxin treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A neurotoxin treatment uses a purified form of botulinum toxin to temporarily relax targeted facial muscles, softening dynamic wrinkles like forehead lines and crow's feet. Botox\u00ae, Dysport\u00ae, and Jeuveau\u00ae are the three FDA-approved options offered at Zenith Wellness."
          }
        },
        {
          "@type": "Question",
          "name": "What's the difference between Botox and Dysport?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Both are botulinum toxin type A injections that work the same way, but Dysport tends to have a slightly faster onset and can spread a bit more, making it a common choice for larger areas like the forehead, while Botox is often chosen for more precise, smaller-area work."
          }
        },
        {
          "@type": "Question",
          "name": "How much does Botox cost in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "At Zenith Wellness, Botox is priced at $11.50 per unit. Total cost depends on the treatment area and number of units needed, which your clinician will determine during your consultation."
          }
        },
        {
          "@type": "Question",
          "name": "How long do neurotoxin results last?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most clients see results within 3\u20137 days, with effects typically lasting 3\u20134 months before a touch-up is needed."
          }
        },
        {
          "@type": "Question",
          "name": "Does Botox hurt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most clients describe minimal discomfort, a series of small pinches during the injections. The appointment itself takes about 15\u201320 minutes with no downtime afterward."
          }
        },
        {
          "@type": "Question",
          "name": "Can Botox help with sweating, not just wrinkles?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Botox is FDA-approved to treat hyperhidrosis (excessive sweating), most commonly in the underarms."
          }
        },
        {
          "@type": "Question",
          "name": "Is Jeuveau the same as Botox?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Jeuveau\u00ae is a different but comparable neuromodulator, sometimes called \"Newtox.\" It works similarly to Botox and Dysport by relaxing targeted muscles, but it's a distinct FDA-approved formulation often available at a different price point."
          }
        },
        {
          "@type": "Question",
          "name": "Where can I get Botox, Dysport, or Jeuveau in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Zenith Wellness is located in Mission Valley at 3727 Camino Del Rio S, Suite 210, San Diego, CA 92108, serving clients across Hillcrest, North Park, La Jolla, and the greater San Diego area. Book online or call 858-905-4117."
          }
        }
      ]
    }
  ],
  "im-shots-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-administered IM shots and vitamin injections for Mission Valley, Hillcrest, North Park, La Jolla and surrounding San Diego neighborhoods.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "La Jolla, San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "IM Shots & Vitamin Injections San Diego",
        "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IM Shots San Diego",
              "serviceType": "Intramuscular Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IM Injections San Diego",
              "serviceType": "Intramuscular Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin Injections San Diego",
              "serviceType": "Vitamin Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Intramuscular Shots San Diego",
              "serviceType": "Intramuscular Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin Shots Mission Valley",
              "serviceType": "Vitamin Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Clinician-Administered Injections San Diego",
              "serviceType": "Clinician-Administered Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin Shots near Mission Valley",
              "serviceType": "Vitamin Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin Injections near Hillcrest",
              "serviceType": "Vitamin Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Hillcrest, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin Injections near North Park",
              "serviceType": "Vitamin Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "North Park, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin Injections near La Jolla",
              "serviceType": "Vitamin Injection",
              "url": "https://zenithwellnesss.com/im-shots-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "La Jolla, San Diego, CA"
              }
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is an IM shot?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "An IM shot (intramuscular shot) is an injection delivered directly into the muscle, allowing vitamins and compounds like B12, MIC, and glutathione to absorb quickly into the bloodstream faster than oral supplements and without the time commitment of an IV drip."
          }
        },
        {
          "@type": "Question",
          "name": "How is an IM injection different from IV therapy?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "IM injections are delivered into the muscle and take just a few minutes, while IV therapy is administered through a vein over 30\u201360 minutes and typically delivers a larger volume of fluids and nutrients. Many clients choose IM shots for quick, targeted support and reserve IV drips for deeper hydration and recovery."
          }
        },
        {
          "@type": "Question",
          "name": "What is a Skinny Shot, and does it help with weight loss?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A Skinny Shot combines MIC (Methionine, Inositol, Choline) with B12 to support fat metabolism, energy, and overall metabolic function. It's not a stand-alone weight-loss treatment, but many clients use it alongside a structured program like GLP-1 or a combination of GLP-1 and GIP for additional metabolic support."
          }
        },
        {
          "@type": "Question",
          "name": "How often can I get a vitamin injection?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Frequency depends on the shot and your goals. Many clients book Vitamin B12 or B-Complex weekly for sustained energy, while others use MIC or Skinny Shots a few times per month alongside a broader wellness or weight-management plan. Our team can help build a schedule during your intake."
          }
        },
        {
          "@type": "Question",
          "name": "Do IM shots hurt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most clients describe a quick pinch, similar to a routine vaccination. The injection itself takes only seconds, and any soreness at the injection site typically resolves within a day."
          }
        },
        {
          "@type": "Question",
          "name": "Are IM injections safe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. All IM shots at Zenith Wellness are administered by trained clinical staff following a brief health intake to confirm the treatment is appropriate for you."
          }
        },
        {
          "@type": "Question",
          "name": "Can I combine multiple IM shots in one visit?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Our Signature Bundles option lets you layer two or more shots together, or add a bundle onto any IV drip for a more targeted result."
          }
        },
        {
          "@type": "Question",
          "name": "Where can I get IM shots in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Zenith Wellness is located in Mission Valley at 3727 Camino Del Rio S, Suite 210, San Diego, CA 92108, conveniently serving clients throughout Hillcrest, North Park, La Jolla, and greater San Diego. Book your visit online or call 858-905-4117."
          }
        }
      ]
    }
  ],
  "iv-therapy-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-led IV therapy, IV hydration and vitamin IV drips for Mission Valley, Hillcrest, North Park, Mission Hills, Kensington and surrounding San Diego neighborhoods.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Mission Hills, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Kensington, San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "IV Therapy San Diego",
        "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy San Diego",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Hydration San Diego",
              "serviceType": "IV Hydration",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy Near Me",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vitamin IV Drip San Diego",
              "serviceType": "Vitamin IV Drip",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Mobile IV Therapy San Diego",
              "serviceType": "Mobile IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Clinician-Led IV Therapy",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Hydration Clinic Mission Valley",
              "serviceType": "IV Hydration",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy near Mission Valley",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy near Hillcrest",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Hillcrest, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy near North Park",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "North Park, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy near Mission Hills",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Hills, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Therapy near Kensington",
              "serviceType": "IV Therapy",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Kensington, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IV Drip San Diego Walk-In",
              "serviceType": "IV Drip",
              "url": "https://zenithwellnesss.com/iv-therapy-san-diego-ca"
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is IV therapy, and how does it work?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "IV therapy delivers fluids, vitamins, and minerals directly into your bloodstream through a small IV line, allowing for faster absorption than oral supplements. At Zenith Wellness, every IV hydration session in San Diego is clinician-supervised from start to finish."
          }
        },
        {
          "@type": "Question",
          "name": "How long does an IV therapy session take?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most IV hydration sessions at our San Diego clinic take between 30 and 60 minutes, depending on the drip and your individual flow rate. NAD+ therapy sessions can run slightly longer due to a slower, more controlled infusion."
          }
        },
        {
          "@type": "Question",
          "name": "Is IV hydration safe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, when administered by trained clinicians in a medical setting. At Zenith Wellness, every client completes a brief health screening before treatment so we can recommend the right IV therapy for your needs and flag any contraindications."
          }
        },
        {
          "@type": "Question",
          "name": "What's the difference between IV therapy and an IM shot?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "IV therapy infuses fluids and nutrients directly into a vein over time, making it ideal for hydration and larger nutrient doses. An IM (intramuscular) shot, like our B12 or Skinny Shot, is a quick injection best for a fast, targeted boost."
          }
        },
        {
          "@type": "Question",
          "name": "What does NAD+ therapy do?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "NAD+ therapy supports cellular energy production, mental clarity, and healthy aging by replenishing a coenzyme your body naturally uses and loses over time. Our NAD+ IV therapy in San Diego is available as a full IV drip or a quicker IM shot."
          }
        },
        {
          "@type": "Question",
          "name": "How often should I get IV therapy?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "It depends on your goals. Many San Diego clients start with a monthly drip for general wellness, while others use IV hydration more frequently for athletic recovery, travel, or immune support. Our memberships are built for clients who want IV therapy as a regular part of their routine."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer IV therapy near me if I'm not in San Diego proper?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our clinic is centrally located in Mission Valley, San Diego, CA, convenient for clients from Hillcrest, North Park, Mission Hills, Kensington, and nearby communities searching for IV therapy near me."
          }
        },
        {
          "@type": "Question",
          "name": "How much does IV therapy cost in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Pricing varies by drip, starting with our Zen Hydration Drip and ranging up to our flagship Zenith Signature Wellness blend. View full pricing on our treatment menu, or ask about membership pricing for ongoing savings."
          }
        }
      ]
    }
  ],
  "medical-weight-loss-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-led, physician-supervised medical weight loss programs, including GLP-1 weight loss, for Mission Valley, Hillcrest, North Park, Kensington and surrounding San Diego neighborhoods.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Kensington, San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Medical Weight Loss San Diego",
        "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Medical Weight Loss San Diego",
              "serviceType": "Medical Weight Loss",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "GLP-1 Weight Loss San Diego",
              "serviceType": "GLP-1 Weight Loss",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Clinic San Diego",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Clinic Near Me",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Injections San Diego",
              "serviceType": "Weight Loss Injection",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Clinician-Led Weight Loss Program",
              "serviceType": "Medical Weight Loss",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Physician-Supervised Weight Loss",
              "serviceType": "Medical Weight Loss",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Clinic Mission Valley",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Mission Valley, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Clinic near Hillcrest",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Hillcrest, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Clinic near North Park",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "North Park, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Weight Loss Clinic near Kensington",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "Kensington, San Diego, CA"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "GLP-1 Clinic 92108",
              "serviceType": "GLP-1 Weight Loss",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca",
              "areaServed": {
                "@type": "Place",
                "name": "San Diego, CA 92108"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Best Weight Loss Clinic San Diego",
              "serviceType": "Weight Loss Clinic",
              "url": "https://zenithwellnesss.com/medical-weight-loss-san-diego-ca"
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is GLP-1 weight loss?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "GLP-1 weight loss uses prescription medications that mimic a naturally occurring hormone to reduce appetite and slow digestion, helping your body lose fat more sustainably. It's one of the most effective medical weight loss options available today when combined with clinical supervision."
          }
        },
        {
          "@type": "Question",
          "name": "Is medical weight loss safe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "When supervised by trained clinicians, medical weight loss with GLP-1 or GLP-1/GIP medications is considered safe for most healthy adults. At Zenith Wellness, every client completes a full health history review before starting a weight loss injections program."
          }
        },
        {
          "@type": "Question",
          "name": "How much weight can I expect to lose with GLP-1 medications?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Results vary by individual, dose, and consistency, and no clinic can guarantee a specific outcome. Your clinician will set realistic expectations based on your health history and help you track progress at regular check-ins."
          }
        },
        {
          "@type": "Question",
          "name": "Do weight loss injections require a commitment to a membership?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. Semaglutide and tirzepatide are available on their own, though many clients choose our GLP Essentials or GLP Premium memberships for bundled pricing and added support like IV hydration and meal planning."
          }
        },
        {
          "@type": "Question",
          "name": "Are there side effects to GLP-1 weight loss medications?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some clients experience mild nausea, digestive changes, or fatigue, especially when starting or increasing a dose. Ongoing medical supervision at our weight loss clinic helps manage side effects and adjust your plan as needed."
          }
        },
        {
          "@type": "Question",
          "name": "Where can I find a weight loss clinic near me in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Zenith Wellness is centrally located in Mission Valley, San Diego, CA, easily accessible for clients searching \"weight loss clinic near me\" from across San Diego County. Contact us to schedule a free consultation."
          }
        }
      ]
    }
  ],
  "peptide-therapy-san-diego-ca": [
    {
      "@context": "https://schema.org",
      "@type": [
        "HealthAndBeautyBusiness",
        "MedicalBusiness"
      ],
      "@id": "https://zenithwellnesss.com/#localbusiness",
      "name": "Zenith Wellness",
      "url": "https://zenithwellnesss.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp"
      },
      "image": "https://customer-assets.emergentagent.com/job_zenith-reserve/artifacts/pq79qyzz_84d55109-d543-4a1a-9205-51b665e4d9d0.webp",
      "description": "Zenith Wellness is a San Diego med spa offering clinician-led, personalized peptide therapy and peptide protocols for weight management, skin health and energy, serving Mission Valley, Hillcrest, North Park, La Jolla and surrounding San Diego neighborhoods.",
      "telephone": "+1-858-905-4117",
      "email": "info@zenithwellness-sd.com",
      "priceRange": "$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "3727 Camino Del Rio S, Suite 210",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "postalCode": "92108",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 32.7774515,
        "longitude": -117.1144108
      },
      "hasMap": "https://www.google.com/maps/place/Zenith+Wellness+Aesthetics+%26+Med+Spa/@32.7774515,-117.1144108,811m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80d95589d34a6d75:0x86e37ae5f83b0b2c!8m2!3d32.7774515!4d-117.1144108!16s%2Fg%2F11ywxpmjxz!5m1!1e2",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Wednesday",
            "Thursday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "@id": "https://en.wikipedia.org/wiki/San_Diego",
          "name": "San Diego",
          "sameAs": "https://en.wikipedia.org/wiki/San_Diego"
        },
        {
          "@type": "Place",
          "name": "Mission Valley, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "Hillcrest, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "North Park, San Diego, CA"
        },
        {
          "@type": "Place",
          "name": "La Jolla, San Diego, CA"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Peptide Therapy San Diego",
        "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Therapy in San Diego, CA",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Therapy San Diego",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptides Near Me",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Therapy Near Me",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Clinic San Diego",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Therapy Clinic San Diego",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Treatment San Diego",
              "serviceType": "Peptide Treatment",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Protocols",
              "serviceType": "Peptide Protocols",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Personalized Peptide Therapy",
              "serviceType": "Personalized Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptides for Weight Management",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptides for Skin Health",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptides for Energy",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peptide Therapy Cost San Diego",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca",
              "areaServed": {
                "@type": "City",
                "name": "San Diego"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Is Peptide Therapy Safe",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "How Does Peptide Therapy Work",
              "serviceType": "Peptide Therapy",
              "url": "https://zenithwellnesss.com/peptide-therapy-san-diego-ca"
            }
          }
        ]
      },
      "sameAs": [
        "https://www.instagram.com/zenithwellness_sd/",
        "https://www.facebook.com/people/Zenith-Wellness/61587655520941/",
        "https://maps.app.goo.gl/ZCuN1HaT3j3uscjj9",
        "https://www.yelp.com/biz/zenith-wellness-san-diego",
        "https://www.mypeptidematch.com/clinic/zenith-wellness-san-diego-ca",
        "https://www.mapquest.com/us/california/zenith-wellness-796284459",
        "https://www.glowlocator.com/clinic/zenith-wellness-in-san-diego",
        "https://www.tiktok.com/@zenith_wellness0",
        "https://reviews.birdeye.com/zenith-wellness-177455245741755",
        "https://zenithwellnesssspace.quora.com/https-www-addonbiz-com-listing-3727-camino-del-rio-s-210-san-diego-ca-92108-united-states-zenith-wellness",
        "https://zenithwellness.setmore.com/",
        "https://peptidesnear.me/listing/zenith-wellness/",
        "https://solo.to/zenithwellness",
        "https://www.medicalspalocator.com/med-spa/zenith-wellness-san-diego-ca"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is peptide therapy, and how does it work?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Peptide therapy uses short chains of amino acids that act as signaling molecules in the body. Prescribed by a licensed clinician, targeted peptides can support processes such as metabolism, skin renewal, recovery and energy. At Zenith Wellness in San Diego, every protocol is customized after a consultation."
          }
        },
        {
          "@type": "Question",
          "name": "Who is a good candidate for peptide therapy in San Diego, CA?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Adults who want a personalized, medically supervised approach to weight management, skin health, energy or overall wellness may be good candidates. Your clinician reviews your health history, current medications and goals to decide whether peptide therapy is appropriate. It isn't right for everyone, and we'll be honest with you about that."
          }
        },
        {
          "@type": "Question",
          "name": "What peptide protocols does Zenith Wellness offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer four protocols: the Comprehensive Wellness Protocol, the Weight Management Protocol, the Skin Health Protocol and the Cellular Energy Protocol. Each is tailored to the individual and can be combined with our IV therapy, GLP-1 programs and skin treatments."
          }
        },
        {
          "@type": "Question",
          "name": "Is peptide therapy safe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Safety starts with a clinical evaluation, quality-sourced medications and ongoing monitoring. Side effects vary by peptide and by person, and your clinician will explain what to expect before you begin. Compounded medications are not FDA-approved, so we recommend reading the FDA's consumer guidance and asking us any questions."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to see results from peptide protocols?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Timelines vary with your goals, your protocol and your body. Some clients notice changes in weeks, while others need several months of consistent care. We set realistic expectations at your consultation and check in regularly so your results stay subtle and sustainable."
          }
        },
        {
          "@type": "Question",
          "name": "Can I combine peptide therapy with weight loss or IV therapy?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Often, yes. Many clients pair their Weight Management Protocol with a GLP-1 program, or their Cellular Energy Protocol with NAD\u207a or IV hydration. Your clinician will confirm what's appropriate for you."
          }
        },
        {
          "@type": "Question",
          "name": "How much does peptide therapy cost in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Cost depends on your protocol, dosing and length of care. We'll give you clear pricing at your consultation, with no surprises. We also offer flexible payment plans through Cherry and CareCredit, and memberships for ongoing care."
          }
        },
        {
          "@type": "Question",
          "name": "Where can I find peptides near me in San Diego?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Zenith Wellness is at 3727 Camino Del Rio S, Suite 210, San Diego, CA 92108, serving Mission Valley, Hillcrest, North Park and surrounding neighborhoods. Call 858-905-4117 or book online to schedule your free consultation."
          }
        },
        {
          "@type": "Question",
          "name": "Do I need a consultation before starting peptides?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Every peptide protocol starts with a consultation so your clinician can review your history and goals, and tell you plainly whether peptide therapy is a good fit."
          }
        }
      ]
    }
  ]
};

export default schemas;
